export const isCreatedByCloudchipr = (createdBy: string | null) => {
  if (!createdBy) {
    return false;
  }
  return createdBy?.toLowerCase() === "cloudchipr";
};
